const elements = document.querySelectorAll('.js-video-button');

elements.forEach((el, index) => {
  if (!el.dataset.youtube) {
    const parent = el.closest('.js-video');
    const video = parent.querySelector('video');

    el.addEventListener('click', event => {
      parent.classList.add('is-playing');
      video.play();
    });

    video.addEventListener('click', event => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    video.addEventListener('ended', event => {
      parent.classList.remove('is-playing');
    });
  }
});

window.onYouTubeIframeAPIReady = function () {
  elements.forEach((el, index) => {
    if (el.dataset.youtube) {
      el.closest('.js-video').classList.add('is-ready');

      const player = new YT.Player(el.dataset.youtube, {
        events: {
          onReady: (event) => {
            el.addEventListener('click', event => {
              player.playVideo();
              el.closest('.js-video').classList.add('is-playing');
            });
          }
        }
      });
    }
  });
}
